<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'App'
}
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue